export default __webpack_public_path__ + "static/media/BIFROST.02fc66f5.png";